import { ListMagnifyingGlass, Plus } from '@phosphor-icons/react';
import { HttpStatusCode } from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccentButtonOutline } from '../../../../../shared/Buttons';
import { VendorBusinessLocation } from '../../../../../types/dbTypes';
import useApi from '../../../../../utils/AxiosWrapper';
import { useScreenView } from '../../../../../utils/ScreenViewContext';
import { useUser } from '../../../../../utils/UserContext';
import BusinessLocationsTable from './widgets/BusinessLocationsTable';

interface VendorLocationsListProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function VendorLocationsList({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: VendorLocationsListProps) {
  const { screenView } = useScreenView();
  const navigate = useNavigate();
  const [loadingLocations, setLoadingLocations] = useState<boolean>(false);
  const [businessLocations, setBusinessLocations] = useState<
    VendorBusinessLocation[]
  >([]);
  const { callProtectedApi } = useApi();
  const { userId } = useUser();
  useEffect(() => {
    const fetchBusinessLocationsForVendor = async (vendor_id: string) => {
      setLoadingLocations(true);
      try {
        const response = await callProtectedApi(
          `/vendorBusinessLocations/list/${vendor_id}`,
          'get',
          {},
          'Error occurred while fetching your business locations.'
        );
        const data = response?.data?.data?.vendorBusinessLocations;
        if (
          data &&
          data?.length > 0 &&
          response?.status === HttpStatusCode.Ok
        ) {
          setBusinessLocations(data);
        }
      } catch (e: any) {
        console.error(
          'Error occurred while fetching your vendor business locations: ',
          e
        );
      } finally {
        setLoadingLocations(false);
      }
    };

    fetchBusinessLocationsForVendor(userId ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <div className="flex h-full items-center justify-center overflow-y-auto overflow-x-hidden px-4 sm:w-[95%] md:w-full lg:w-[1148px] lg:max-w-[1148px] lg:px-0">
            {/* <OnboardingModal /> */}
            <div className="flex h-full w-full flex-col space-y-[16px] pt-[16px]">
              <div className="flex w-full flex-row items-end justify-end">
                <AccentButtonOutline
                  onClick={() => navigate('/dashboard/locations/create')}
                  addClass="h-[48px] max-h-[48px] w-[196px] max-w-[196px] rounded-full"
                >
                  <div className="flex h-full w-full flex-row items-center justify-center space-x-2 align-middle">
                    <Plus />
                    <p>Add New Location</p>
                  </div>
                </AccentButtonOutline>
              </div>
              {businessLocations && businessLocations?.length > 0 ? (
                <div className="flex h-full w-full flex-row">
                  <BusinessLocationsTable
                    locations={businessLocations}
                    loading={loadingLocations}
                  />
                </div>
              ) : (
                <div className="flex h-full w-full flex-col items-center justify-center gap-y-6 bg-white p-8 align-middle lg:w-[1148px] lg:max-w-[1148px]">
                  <div className="flex h-[64px] w-[64px] flex-col items-center justify-center rounded-[4px] border-[1px] border-[#EAECF0] bg-[#F5F6F7]">
                    <ListMagnifyingGlass
                      size={40}
                      className="text-graysecondary"
                      weight="bold"
                    />
                  </div>
                  <div className="flex flex-col items-center justify-center gap-y-1 align-middle">
                    <h2 className="text-[16px] text-primary">
                      No Locations to Display
                    </h2>
                    <p className="text-center text-[14px] text-graysecondary">
                      Get started by adding your first business location.
                    </p>
                  </div>
                  <AccentButtonOutline
                    onClick={() => navigate('/dashboard/locations/create')}
                    addClass="rounded-full text-primary h-[32px] w-[196px] flex flex-row items-center justify-center space-x-2 align-middle"
                  >
                    <Plus size={20} />
                    <h2 className="text-[14px]">Add Location</h2>
                  </AccentButtonOutline>
                </div>
              )}
            </div>
          </div>
        );
    }
  };
  return <>{renderScreenView(screenView)}</>;
}

export default VendorLocationsList;
